export default "/images/vendor/flag-icon-css/flags/1x1/ch.svg?1113c7e9162d605ca580694f60526e96";